import { Input } from '@m/alchemy-ui/Input';
import { Control, useController, useFormContext } from 'react-hook-form';
import { FieldDescription } from 'admin/company/components/ManageTeam/Styled/Styled';
import { validationMessages } from './validationMessages';
import { StyledField } from '../styles';

interface TextFieldProps {
  name: string;
  label?: string;
  tip?: string;
  placeholder?: string;
  isFullWidth?: boolean;
  control: Control;
  required?: boolean;
  validate?: any;
  triggerFields?: string[];
}

export const TextField = ({
  name,
  label = '',
  tip,
  placeholder = '',
  isFullWidth = true,
  control,
  required = false,
  validate = {},
  triggerFields,
}: TextFieldProps) => {
  const { trigger } = useFormContext();
  const hasValidateRule =
    typeof validate === 'function' ||
    (validate && typeof validate === 'object' && Object.keys(validate).length > 0);

  // execute validate prop if present
  const ruleOptions = {
    ...(required && { required: validationMessages.required }),
    ...(hasValidateRule && { validate }),
  };

  const { field, fieldState } = useController({
    name,
    control,
    rules: ruleOptions,
  });
  const { invalid, error } = fieldState;

  return (
    <StyledField
      labelVariant="emphasized"
      isFullWidth={isFullWidth}
      required={required}
      id={`action-text-${name}`}
      label={label}
      status={invalid ? { level: 'error', message: error?.message } : undefined}
      helpText={tip}
      description={<FieldDescription>{tip}</FieldDescription>}
      input={
        <Input
          {...field}
          isFullWidth={isFullWidth}
          placeholder={placeholder}
          value={field.value ?? ''}
          onChange={e => {
            field.onChange(e.target.value);
            if (triggerFields?.length) {
              trigger(triggerFields);
            }
          }}
        />
      }
    />
  );
};
